module.exports = __webpack_public_path__ + "img/about.b51be69c.jpg";